import React, { useCallback, useEffect, useRef, useState } from "react";
import { Button, FormControl, InputGroup, Modal } from "react-bootstrap";
import { csrfHeader } from "./lib/utils";
import debounce from "lodash/debounce";

export const RakutenCategories = ({ onClose, categoryId, amazonCategoryId }) => {
    const [candidates, setCandidates] = useState([]);
    const [show, setShow] = useState(true);
    const inputRef = useRef();
    const searchFn = useCallback(debounce(() => {
        const q = inputRef.current.value;
        fetch(`/api/categories?q=${q}`, {
            mode: 'cors',
        }).then(res => res.json()).then(res => setCandidates(res));
    }, 1000), [inputRef]);
    useEffect(() => {
        fetch(`/api/categories/${categoryId}`, {
            mode: 'cors',
        }).then(res => console.log(res));
    }, []);
    const handleClose = () => {
        setShow(false);
        onClose();
    };
    const setCategory = async (service_category_id) => {
        const res = await fetch(`/api/category_mappings`, {
            mode: "cors",
            credentials: "include",
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
                ...csrfHeader(),
            },
            body: JSON.stringify({
                amazon_category_id: amazonCategoryId,
                service_category_id,
            })
        });
        const body = await res.json();
        console.log(body);
        location.reload();
    };
    return <>
        <Modal show={show} onHide={handleClose} centered>
            <Modal.Header closeButton>
                <Modal.Title>カテゴリ設定</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div>
                    <InputGroup className="mb-3">
                        <FormControl
                            placeholder="カテゴリを検索"
                            aria-label="カテゴリを検索"
                            aria-describedby="basic-addon2"
                            ref={inputRef}
                            onChange={searchFn}
                        />
                        <Button variant="outline-secondary" onClick={searchFn}>
                            <i className="fas fa-search" />
                        </Button>
                    </InputGroup>
                    {
                        candidates.length > 0 &&
                        <ul>
                            {
                                candidates.map(({ category_id, name }, i) =>
                                    <li key={`category-candidate-${i}`}>
                                        <a href='javascript:void(0)' onClick={() => setCategory(category_id)}>{name}({category_id})</a></li>)
                            }
                        </ul>
                    }
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="primary" onClick={handleClose}>
                    閉じる
                </Button>
            </Modal.Footer>
        </Modal>
    </>;
};
